module.exports = __webpack_public_path__ + "img/close.6130a3c0.svg";